/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import SymbolSubstitutionBase, { SymbolStack } from "./SymbolSubstitutionBase";

/** @hidden */
// tslint:disable-next-line:typedef
const ccclass = cc._decorator.ccclass;
/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@ccclass
export default class SymbolSubstitutionComponent extends SymbolSubstitutionBase
{
    @property({ type: [SymbolStack], visible: true })
    protected ReelSymbolStacks: SymbolStack[] = [];

    @property({ type: [cc.String], visible: true })
    protected StackSymbolSuffixes: string[] = [];

    public get IsContinuous(): boolean { return false; }

    /**
     * Substitutes symbols in the provided reel strip based on how this component
     * is configured in the Cocos Editor. NOTE: Does not behave as expected with stack
     * symbols which wrap from the end to the beginning of the strip.
     * @param reelStrip - The reel strip to run the substitution on.
     * @returns The substituted reel strip.
     */
    public SubstituteReelSymbols(reelStrip: string[], reelIndex: number): string[]
    {
        let aNewReelSymbols: string[] = [];

        // Running the search on all of them
        for (let nSymbolIndex: number = 0; nSymbolIndex < reelStrip.length; ++nSymbolIndex)
        {
            // Get the Current Reel Symbol Letter
            let strTestLetter: string = reelStrip[nSymbolIndex];
            // And Check if it is one we should be replacing
            let nReplaceLetterIndex: number = this.ReelSymbolStacks.findIndex((value): boolean => {
                return value.StackSymbol === strTestLetter;
            });

            // If So
            if (nReplaceLetterIndex >= 0)
            {
                // Get the Replace Letter to use to construct our new strings
                let strReplaceLetter: string = this.ReelSymbolStacks[nReplaceLetterIndex].StackSymbol;

                // Figure out how tall this stack is
                let nStackLength: number = this.ReelSymbolStacks[nReplaceLetterIndex].StackLength;

                // Compute where this stack will start and stop
                let nHeadIndex: number = nSymbolIndex;
                let nReplaceIndex: number = 0;
                let nTailIndex: number = nHeadIndex + (nStackLength - 1);

                for (let nStackIndex: number = 0; nStackIndex < nStackLength; ++nStackIndex)
                {
                    nReplaceIndex = nHeadIndex + nStackIndex;
                    if (reelStrip[nReplaceIndex] === strReplaceLetter && nReplaceIndex <= nTailIndex)
                    {
                        aNewReelSymbols[nReplaceIndex] = strReplaceLetter + this.StackSymbolSuffixes[nStackIndex];
                    }
                    else if (nReplaceIndex < reelStrip.length)
                    {
                        // Put in the original symbol
                        aNewReelSymbols[nReplaceIndex] = reelStrip[nReplaceIndex];
                        break;
                    }
                }

                // Now move the original loop to the tail so we increment past the stack
                // we just replaced
                nSymbolIndex = nReplaceIndex;
            }
            else
            {
                // Put in the original symbol
                aNewReelSymbols[nSymbolIndex] = reelStrip[nSymbolIndex];
            }
        }

        return aNewReelSymbols;
    }
}
